module.exports = __webpack_public_path__ + "files/2cc4cd75106c65318a3a782eb20c7e3e.png";